<script lang="ts" setup>
import { useWorkspaceEntityStore } from '#layers/runtime/public';

const { id } = defineProps<{
	id: string;
}>();

const emit = defineEmits<{
	close: [];
}>();

const store = useWorkspaceEntityStore();

// eslint-disable-next-line vue/no-setup-props-reactivity-loss -- the edit form binds the record this instance was opened for
const editPageSection = await store.MonospacePageSection.updateForm(id);

editPageSection.$onSuccess(() => {
	emit('close');
});
</script>

<template>
	<DDialog :title="$t('page_section.edit.title')">
		<template #body>
			<DForm
				id="page-section-edit-form"
				:state="editPageSection"
				:schema="editPageSection.$schema"
				layout="side-by-side"
				auto-focus-first-input
				@submit="editPageSection.$submit()"
			>
				<DFormField
					name="title"
					:label="$t('page_section.title')"
				>
					<DInput
						v-model="editPageSection.title"
						:placeholder="$t('page_section.title_placeholder')"
					/>
				</DFormField>
			</DForm>
		</template>

		<template #footer>
			<DButton
				:label="$t('common.cancel')"
				color="neutral"
				variant="outline"
				size="sm"
				@click="emit('close')"
			/>

			<DButton
				type="submit"
				form="page-section-edit-form"
				:label="$t('page_section.edit.submit')"
				size="sm"
			/>
		</template>
	</DDialog>
</template>
